// src/utils/postexApi.js
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Create Order on PostEx via API
 */
export const bookOrderOnPostEx = async (order) => {
  try {
    // 1. Fetch PostEx settings
    const settingsRef = doc(db, 'settings', 'postex');
    const settingsSnap = await getDoc(settingsRef);

    if (!settingsSnap.exists()) {
      return { success: false, error: 'PostEx settings not configured' };
    }

    const settings = settingsSnap.data();

    if (settings.active === false) {
      return { success: false, error: 'PostEx integration disabled' };
    }

    if (!settings.apiToken) {
      return { success: false, error: 'PostEx API Token missing' };
    }

    // 2. Build order detail
    const orderDetail = (order.items || [])
      .map(item => `${item.title} x${item.quantity}`)
      .join(', ');

    // 3. ✅ Order Reference Number = SIRF "Mr"
    const orderRefNumber = 'Mr';

    // 4. Build payload
    const payload = {
      orderRefNumber: orderRefNumber,
      invoicePayment: order.total || 0,
      orderDetail: orderDetail,
      customerName: order.customerName || '',
      customerPhone: order.phone || '',
      deliveryAddress: `${order.address || ''}${order.state ? ', ' + order.state : ''}${order.postalCode ? ' - ' + order.postalCode : ''}`,
      cityName: order.city || '',
      items: 1,
      orderType: 'Normal',
      pickupAddressCode: settings.pickupAddressCode || '',
      returnAddressCode: settings.returnAddressCode || '',
      pickupCity: settings.pickupCity || 'Rawalpindi',
      pickupAddress: settings.pickupAddress || '',
      returnCity: settings.returnCity || 'Rawalpindi',
      returnAddress: settings.returnAddress || '',
      bookingWeight: settings.defaultWeight || 0.5,
      notes: '',
    };

    console.log('📤 PostEx Payload:', payload);

    // 5. Send to PostEx API
    const response = await fetch('https://api.postex.pk/services/integration/api/order/v3/create-order', {
      method: 'POST',
      headers: {
        'token': settings.apiToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();
    console.log('📥 PostEx Response:', data);

    // ✅ Check status code
    const statusCode = data.statusCode || data.code;
    const statusMessage = data.statusMessage || data.message || '';

    // ✅ SUCCESS conditions
    const isSuccess =
      statusCode === 200 ||
      statusCode === '200' ||
      statusMessage.toUpperCase().includes('ORDER HAS BEEN CREATED') ||
      statusMessage.toUpperCase().includes('CREATED') ||
      (data.dist && data.dist.trackingNumber);

    if (isSuccess) {
      // Extract tracking number
      let trackingNumber = '';

      if (data.dist) {
        trackingNumber =
          data.dist.trackingNumber ||
          data.dist.cn ||
          data.dist.consignmentNumber ||
          data.dist.CN ||
          '';
      }

      if (!trackingNumber && data.dist?.trackingData) {
        trackingNumber = data.dist.trackingData.trackingNumber || '';
      }

      console.log('✅ PostEx Success. CN:', trackingNumber);

      return {
        success: true,
        trackingNumber: trackingNumber,
        orderId: data.dist?.orderId || '',
        message: 'Order booked successfully!',
      };
    }

    // ❌ Real error
    console.error('❌ PostEx Error:', data);
    return {
      success: false,
      error: statusMessage || 'PostEx API failed',
    };

  } catch (error) {
    console.error('PostEx API error:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Track order
 */
export const trackPostExOrder = async (trackingNumber) => {
  try {
    const settingsRef = doc(db, 'settings', 'postex');
    const settingsSnap = await getDoc(settingsRef);
    if (!settingsSnap.exists()) return null;

    const settings = settingsSnap.data();

    const response = await fetch(
      `https://api.postex.pk/services/integration/api/order/v1/track-order/${trackingNumber}`,
      {
        method: 'GET',
        headers: { 'token': settings.apiToken },
      }
    );

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('PostEx tracking error:', error);
    return null;
  }
};

export default bookOrderOnPostEx;